import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
 



class FindAllView extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    async componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
        }
    }

    render() {

        let mainContent;

        mainContent = <div
            id={"FindAllView"}   className='findAllView' style={{ backgroundColor:'#bce8f1',color:'#3a87ad'}}>

            <div className="findAllView_close" onClick={() => {
                //document.getElementById('FindAllView').style.display = 'none';
                this.props.closefindAllView();

            }}>x</div>


            {this.props.children}


        </div>;

        return (mainContent);
    }
}


FindAllView.propTypes = {
    errors: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    project: state.project,
    errors: state.errors
});

export default connect(mapStateToProps, { })(
    withRouter(FindAllView)
);



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindAllView.js